import { css } from '@bd/bdui-styles/emotion';

const successForms = css`
  font-weight: 400;
  font-size: 22px;
  color: #000;
  letter-spacing: 1px;
  text-align: center;
  position: relative;
  text-align: center;
  padding: 50px 0;
  @media(min-width: 992px) {
  padding: 80px 0;
    font-size: 26px;
  }
  b {
    font-weight: 800;
    font-size: 24px;
    color: #000;
    letter-spacing: 1px;
    text-transform: uppercase;
    position: relative;
    text-align: center;
    @media(min-width: 992px) {
      font-size: 28px;
    }
  }
  p {
    font-weight: 400;
    font-size: 22px;
    color: #000;
    letter-spacing: 2.57px;
    text-align: center;
    position: relative;
    text-align: center;
    @media(min-width: 992px) {
      font-size: 26px;
    }
  }
`;

export default successForms;



// WEBPACK FOOTER //
// ./src/styles/successForms.js